/**
 * 基础类，提供类的创建和继承
 *
 * @example
 *
 *      var Pig = Class.create({
 *          // initialize方法在构造实例时调用
 *          initialize: function(name) {
 *              this.name = name;
 *          },
 *
 *          talk: function() {
 *              console.log('I am' + this.name);
 *          }
 *      });
 *
 *      var RedPig = Pig.extend({
 *          initialize: function(name) {
 *              // 调用父类的同名方法
 *              RedPig.superclass.initialize.call(this, name);
 *          },
 *
 *          color: 'red'
 *      });
 *
 *      var props = {
 *          fly: function() {
 *              console.log('fly');
 *          }
 *      }
 *
 *      var FlyableRedPig = RedPig.extend({
 *          // 将props的属性或者原型混入新的类中
 *          Implements: props,
 *
 *          initialize: function(name) {
 *              FlyableRedPig.superclass.initialize.call(this, name);
 *          }
 *      });
 *
 *
 *      // 类已经存在，动态修改
 *      FlyableRedPig.implements({
 *          swim: function() {
 *              console.log('swim');
 *          }
 *      })
 */
define(function() {

    function Class(o) {
        // 转换存在的函数为Class
        if (!(this instanceof Class) && isFunction(o)) {
            return classify(o);
        }
    }

    // 创建类
    //  var Pig = Class.create({
    //      Extends: Animal,
    //      Implements: Flyable,
    //      initialize: function() {
    //          Pig.superclass.initialize.apply(this, arguments);
    //      },
    //      Statics: {
    //          COLOR: "red"
    //      }
    //  })
    Class.create = function(parent, properties) {
        if (!isFunction(parent)) {
            properties = parent;
            parent = null;
        }

        properties || (properties = {});
        parent || (parent = properties.Extends || Class);
        properties.Extends = parent;

        // 创建类的构造函数
        function SubClass() {
            // 组合继承
            // 继承parent的属性，但是这里SubClass仍然不能调用parent在原型定义的方法
            // 需要在后面调用SubClass.prototype = new parent();
            parent.apply(this, arguments);

            // 调用自己的initialize函数
            if (this.constructor === SubClass && this.initialize) {
                this.initialize.apply(this, arguments);
            }
        }

        // 添加父类属性
        // 如果指定了数组StaticsWhiteList，则只添加StaticsWhiteList指定的属性
        if (parent !== Class) {
            mix(SubClass, parent, parent.StaticsWhiteList);
        }

        // 添加实例属性
        implement.call(SubClass, properties);

        // 让类为可继承的
        return classify(SubClass);
    };

    function implement(properties) {
        var key, value;

        for (key in properties) {
            value = properties[key];

            if (Class.Mutators.hasOwnProperty(key)) {
                Class.Mutators[key].call(this, value);
            } else {
                this.prototype[key] = value;
            }
        }
    }

    // 作用同Class.create
    Class.extend = function(properties) {
        properties || (properties = {});
        properties.Extends = this;

        return Class.create(properties);
    };


    function classify(cls) {
        cls.extend = Class.extend;
        cls.implement = implement;
        return cls;
    }


    Class.Mutators = {
        // 单个继承
        'Extends': function(parent) {
            var existed = this.prototype;
            var proto = createProto(parent.prototype);

            // 保存现有的属性
            mix(proto, existed);

            // 保持constructor指向
            proto.constructor = this;

            // 重要：原型继承
            this.prototype = proto;

            // 设置该属性用于访问父类原型方法
            this.superclass = parent.prototype;
        },

        // 支持多个
        // 将 items 各项的原型或者属性混合到类的原型中
        'Implements': function(items) {
            isArray(items) || (items = [items]);
            var proto = this.prototype, item;

            while (item = items.shift()) {
                mix(proto, item.prototype || item);
            }
        },

        'Statics': function(staticProperties) {
            mix(this, staticProperties);
        }
    };


    // Shared empty constructor function to aid in prototype-chain creation.
    function Ctor() {
    }

    // See: http://jsperf.com/object-create-vs-new-ctor
    var createProto = Object.__proto__ /* eslint no-proto: 0 */
        ? function(proto) {
            return { __proto__: proto };
        }
        : function(proto) {
            Ctor.prototype = proto;
            return new Ctor();
        };


    // Helpers
    // ------------

    function mix(r, s, wl) {
        // Copy "all" properties including inherited ones.
        for (var p in s) {
            if (s.hasOwnProperty(p)) {
                if (wl && indexOf(wl, p) === -1) continue;

                // 在 iPhone 1 代等设备的 Safari 中，prototype 也会被枚举出来，需排除
                if (p !== 'prototype') {
                    r[p] = s[p];
                }
            }
        }
    }


    var toString = Object.prototype.toString;

    var isArray = Array.isArray || function(val) {
        return toString.call(val) === '[object Array]';
    };

    var isFunction = function(val) {
        return toString.call(val) === '[object Function]';
    };

    var indexOf = Array.prototype.indexOf ?
        function(arr, item) {
            return arr.indexOf(item);
        } :
        function(arr, item) {
            for (var i = 0, len = arr.length; i < len; i++) {
                if (arr[i] === item) {
                    return i;
                }
            }
            return -1;
        };


    return Class;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/cui/core/class/class.js
 ** module id = 28
 ** module chunks = 13 14
 **/